import ClientPrePaymentItem from '../Domain/ClientPrePaymentItem';
import AuthService from './authService';
import SearchParams from '../Elements/SearchParams';
import ClientPrePaymentsSearchParams from '../Contents/Finance/ClientPrePayment/ClientPrePaymentsSearchParams';
import TpClientPrePaymentsSearchParams from '../Contents/ThirdParty/TpClientPayment/ClientPrePayment/ClientPrePaymentsSearchParams';

export default class ClientPrePaymentService {
  static GetPrePaymentsBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, ClientPrePaymentsSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/VZeusClientLineBase/GetPrepaymentsAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetTpRelatedPrePaymentsBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, TpClientPrePaymentsSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/VZeusClientLineBase/GetTpRelatedPrepaymentsAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertPrePaymentDBItems(itemlist) {
    let mappedItems = [];

    if (itemlist !== null) {
      mappedItems = itemlist.map((item) => new ClientPrePaymentItem(item));
    }

    return mappedItems;
  }

  static GetByPrePaymentId(id) {
    return AuthService.getInstance().CallBackendFunction(`/api/VZeusClientLineBase/GetById/${id ? id : 0}`);
  }

  static ChangeProjectOfPrepayment(item) {
    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/ClientLine/ChangeProjectOfPrepaymentAsync/',
      JSON.stringify(item)
    );
  }
}
